<template>
  <v-col class="full-height pr-12">
    <v-row class="hide-scrollbar custom-row">
      <v-container class="ma-0 text-center d-inline">
        <v-container class="d-block">
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="makeDeliverableList"
              :search="search"
              :loading="loading"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              item-key="id"
              show-expand
              class="elevation-1"
              loading-text="Loading... Please wait"
              @click:row="expandItem"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                <MakeDeliverableDettails :item="[item]"/>
                </td>
              </template>
              <template v-slot:[`item.deliveredBy`]="{ item }">
                <div
                  class="text-truncate"
                  style="max-width: 400px"
                  :title="item.deliveredBy"
                >{{ item.deliveredBy }}</div>
              </template>
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ new Date(item.createdAt).toLocaleString() }}
              </template>
              <template v-slot:[`item.move`]="{ item }">
                <v-icon
                  v-if="item.move"
                  dark
                  color="success"
                  title="move"
                  >mdi-share-all</v-icon
                >
                <v-icon
                  v-else
                  dark
                  color="primary"
                  title="SFTP sharing"
                  >mdi-file-move</v-icon
                >
              </template>
              <template v-slot:no-data>
                <span color="primary">No data to show you</span>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-container>
    </v-row>
  </v-col>
</template>
<script>
import { mapState } from "vuex";
import MakeDeliverableDettails from '@/components/MakeDeliverableDettails.vue';

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Requestor", value: "deliveredBy" },
      { text: "Creation Date", value: "createdAt", align: "center" },
      { text: "Action", value: "move", align: "center" },
      { text: "State", value: "status", align: "center" },
    ],
    loading: false,
    expanded: [],
    singleExpand: false
  }),
  components: {
    MakeDeliverableDettails
  },
  computed: {
    ...mapState({
      makeDeliverableList: (state) => state.makeDeliverableList,
    }),
  },
  created: async function () {
    this.loading = true;
    await this.$store.dispatch("listMakeDeliverable");
    this.loading = false;
  },
  methods: {
    expandItem(event) {
        var isOpen = false;
        this.expanded.filter(el => {
          if (el.id == event.id) {
            isOpen = true;
          } else {
            isOpen = false;
          }
        })
        if (isOpen) {
          this.expanded = [...this.expanded.filter(el => el.id != event.id)];
        } else {
          this.expanded.push(event);
        }
    }
  }
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-bottom: 10em;
  display: block;
}
.custom-row {
  overflow-y: scroll;
  height: inherit;
}
.in-progress-loader{
  width: 1.5em;
  display: flex;
}
</style>
